import I18Service from 'ReactZeroniUI/I18n/i18n.service';
(function () {
  'use strict';

  angular
    .module('blocks.i18n')
    .service('i18nService', i18nService);

  /* @ngInject */
  function i18nService(
    messagesDeService,
    messagesEnService,
    messagesEtService,
    messagesFiService,
    messagesPlService,
    messagesOverrideService,
    messagesRuService,
    messagesSkService,
    messagesSvService,
  ) {


    this.get = get;
    this.getOrThrow = getOrThrow;

    function get(stringNameParam, stringArgs) {
      if (!stringNameParam) {
        return '';
      }

      const stringName = messagesOverrideService.applyOverride(stringNameParam);

      let message;

      // Retrieving a cookie
      const lang = I18Service.getLanguage();

      const defaultLangService = messagesEnService;
      const langServices = {
        de: messagesDeService,
        en: messagesEnService,
        et: messagesEtService,
        fi: messagesFiService,
        pl: messagesPlService,
        ru: messagesRuService,
        sk: messagesSkService,
        sv: messagesSvService,
      };

      const key = stringName.trim();
      message = langServices[lang] && langServices[lang].messages[key] || defaultLangService.messages[key] || stringName;

      if (typeof stringArgs === 'undefined') {
        return message;
      }

      if (stringArgs instanceof Array) {
        for (let i in stringArgs) {
          message = message.split('{' + i + '}').join(stringArgs[i]);
        }
      } else {
        message = message.split('{0}').join(stringArgs);
      }

      return message;
    }

    function getOrThrow(stringName, stringArgs) {
      var string = get(stringName, stringArgs);
      if (string === undefined) {
        throw 'String ' + stringName + ' not found!';
      }
      return string;
    }

  }

})();
